import dayjs from "dayjs";
import "dayjs/locale/ko";

import useViewMode from "@/hooks/useViewMode";
import AdminDashboard from "@/pages/Dashboard/AdminDashboard";
import UserDashboard from "@/pages/Dashboard/UserDashboard";

dayjs.locale("ko");

// ============================================
// 메인 Dashboard: 역할에 따라 분기
// ============================================

const Dashboard = () => {
  const { isAdmin } = useViewMode();

  return isAdmin ? <AdminDashboard /> : <UserDashboard />;
};

export default Dashboard;
